import script from "./ChatListEmpty.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatListEmpty.vue?vue&type=script&setup=true&lang=ts"

import "./ChatListEmpty.vue?vue&type=style&index=0&id=f556a6dc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f556a6dc"]])

export default __exports__